import React, { useState } from "react";
import { LOGIN } from "../config/api";
import {jwtDecode} from "jwt-decode";
import Cookies from "js-cookie";

export default function Login() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");

  const handleSubmit = async (e) => {
    e.preventDefault();
  
    // Basic required validation
    if (!email || !password) {
      console.log("Email and password are required");
      return;
    }
  
    try {
      const response = await fetch(LOGIN, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ email, password }),
      });
  
      if (response.ok) {
        const data = await response.json();
        console.log(data)
        // Check if token exists and is a valid string before decoding
        if (data.response && typeof data.response === "string") {
          const decodedToken = jwtDecode(data.response);
          console.log("Login successful:", decodedToken);
          Cookies.set("authToken", data.response, { expires: 30 });
          if(decodedToken.claims.role==="ADMIN"){
            window.location.href = "#/dashboard"
          } else if(decodedToken.claims.role==="EMPLOYEE"){
            window.location.href = "#/email"
          }
        } else {
          console.log("Token is missing or invalid.");
        }
      } else {
        console.log("Login failed:", response.statusText);
      }
    } catch (error) {
      console.log("An error occurred:", error);
    }
  };
  

  return (
    <div className="container-scroller">
      <div className="container-fluid page-body-wrapper full-page-wrapper">
        <div className="row w-100 m-0">
          <div className="content-wrapper full-page-wrapper d-flex align-items-center auth login-bg">
            <div className="card col-lg-4 mx-auto">
              <div className="card-body px-5 py-5">
                <h3 className="card-title text-left mb-3">Login</h3>
                <form onSubmit={handleSubmit}>
                  <div className="form-group">
                    <label>Email<sup className="text-danger">*</sup></label>
                    <input
                      type="text"
                      className="form-control p_input"
                      value={email}
                      onChange={(e) => setEmail(e.target.value)}
                      required
                    />
                  </div>
                  <div className="form-group">
                    <label>Password<sup className="text-danger">*</sup></label>
                    <input
                      type="password"
                      className="form-control p_input"
                      value={password}
                      onChange={(e) => setPassword(e.target.value)}
                      required
                    />
                  </div>
                  <div className="form-group d-flex align-items-center justify-content-between">
                    <div className="form-check">
                      <label className="form-check-label">
                        <input type="checkbox" className="form-check-input" /> Remember me
                      </label>
                    </div>
                  </div>
                  <div className="text-center">
                    <button type="submit" className="btn btn-primary btn-block enter-btn">
                      Login
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
